module.exports = __webpack_public_path__ + "static/media/view2.fedaa78f.jpg";